<template>
  <div class="main" :class="{ backColorB: bCb }" @click="clearRightMenu"
       @click.right="clearRightMenu" ref="main">
    <!-- <editorHeader :isBack="isBack" :saveHint="saveHint" :bCbs="bCb" :progress="progress"
                  :queryDatas="queryData">
    </editorHeader> -->
    <div class="editor-header-top">
      <editor-header></editor-header>
    </div>

    <!-- @visionPattern="visionPattern" -->
    <editorTop :taskTypeNames="taskTypeName" :queryDatas="queryData" :bCb="bCb"
               :isSeekBoxs="isSeekBox" :isSplits="isSplit" :ifSubmits="ifSubmit"
               :termSubmits="termSubmit" :roleLevel="roleLevel" :interpreteruids="interpreteruid"
               :sentenceShows="sentenceShow" :isSourceEds="isSourceEd"
               @splitSentence="splitSentence" :isPreMts="isPreMt" @mergeSentence="mergeSentence"
               @seekShow="seekShow" @rigBoxShow="rigBoxShow" @sizeEnlarge="sizeEnlarge"
               @sizeNarrow="sizeNarrow" @submit="submit" @reTranslate="reTranslate"
               @copySource="copySource" @anewTranslate="anewTranslate" @sourceEditor="sourceEditor"
               @setRecord="setRecord" @interpreterTask="interpreterTask"
               @interpreterTaskOut="interpreterTaskOut" @toTaskIndex="toTaskIndex"
               :states="state" />

    <div id="bagBox" :class="{ backColorB: bCb }">
      <div class="box cat-trans" id="redactBox" ref="redactBox">
        <div class="lef" id="sourceText" @mouseover="styleOver($event)" @mouseout="styleOut($event)"
             @mouseup="pitchOn" @contextmenu="oncontextmenu" @click="getHint($event)" max="15">
          <h4 class="tit">
            <h3></h3>
            原文
          </h4>
          <div class="lef-box-main" style="
              overflow-y: auto;
              height: 100%;
              padding: 40px;
              position: relative;
              padding-top: 0px;
              box-sizing: border-box;
            " ref="viewBox">
            <div ref="sourceBox" v-for="(item, index) in sourceList" :key="index"
                 v-html="item.data"></div>
          </div>
        </div>
        <div class="rig" id="translation" @mouseup="pitchOn($event, 1)"
             @mouseover="styleOver($event)" @mouseout="styleOut($event)" @click="getHint($event, 1)"
             @contextmenu="oncontextmenu($event, 1)" @input="AutoComple($event)">
          <h4 class="tit">
            <h3></h3>
            译文
          </h4>
          <div class="right-box-main" style="
              overflow-y: auto;
              height: 100%;
              position: relative;
              padding: 40px;
              padding-top: 0px;
              box-sizing: border-box;
            " ref="viewBox2">
            <div ref="targetBox" v-for="(item, index) in targetList" :key="index"
                 v-html="item.data"></div>
            <postil style="top: 5px" :isAddPostil="isAddPostil" :isUpdatePostil="isUpdatePostil"
                    @setIsSeekBox="setIsSeekBox" />
          </div>
        </div>
      </div>
      <div class="rigContantBox" ref="rigContantBox">
        <i class="icon-left riBoxSw" v-show="RigBoxIf" @click="startRigBox"></i>
        <i class="icon-right riBoxSw" v-show="!RigBoxIf" @click="startRigBox"></i>
        <!-- :queryDatas="queryData"  -->
        <editorOperation ref="editorOperation" :termHintList="termHintList" :queryData="queryData"
                         :memoryHintList="memoryHintList" :isSeekBox="isSeekBox" :seekTxt="seekTxt"
                         :seekTxt2="seekTxt2" :seekNum="seekNum" :seekNum2="seekNum2"
                         :inputTxt="inputTxt" :bCb="bCb" :targetInput="targetInput"
                         :postilTarget="postilTarget" :ifSubmit="isUpdatePostilBut"
                         :updatePostilTxt="updatePostilTxt" :postilId="postilId" @addTerm="addTerm"
                         @onInputTxt="onInputTxt" @onTargetInput="onTargetInput"
                         @onSeekTxt="onSeekTxt" @onSeekTxt2="onSeekTxt2" @setPostilId="setPostilId"
                         @onUpdatePostilTxt="onUpdatePostilTxt" @setIsSeekBox="setIsSeekBox"
                         @goQA="goQA" @seekChange="seekChange" @onReplace="onReplace"
                         @replaceChange="replaceChange" @previous="previous" @seekNext="seekNext">
        </editorOperation>
      </div>
    </div>
    <rightMenu ref="rightMenu" v-show="rightMenuShow" @rigBoxShow="rigBoxShow"
               @rigAddTerm="rigAddTerm" @anewTranslate="anewTranslate"
               @mergeSentence="mergeSentence" @splitSentence="splitSentence"
               :format="(queryData.fileSuffix)" @unlockSentence="unlockSentence"
               :sentenceShow="sentenceShow" :inputTxt="inputTxt" :typeShow="typeShow"
               :ifSubmit="ifSubmit" :isEditR="isEditR" :isLock="isLock" @copySource="copySource"
               @rigClick="rigClick">
    </rightMenu>
    <messageBox v-if="mesBox" :isShow="mesBox" :tit="tit" :txt="txt" :imgSrc="imgSrc" :cancel="true"
                confirmBut="保存并替换" callBut="保存至术语表" @message="empty" @messageIf="messageIf"
                @onCancel="onCancel"></messageBox>
    <!-- 单词补全开始 -->
    <div id="WordBox" ref="WordBox" v-show="isWordBox">
      <ul>
        <li v-for="(item, index) in words" :key="index">
          {{ item }}
        </li>
      </ul>
      <ul>
        <li></li>
      </ul>
    </div>
    <!-- 单词补全结束 -->

    <!-- 术语添加弹窗 -->
    <termDialog :dialogVisible="dialogVisible"></termDialog>
    <!-- 术语添加弹窗 -->

    <!-- 新手引导 -->
    <!-- <noviceGuide :isNovice="isNovice" :index="numOfGuide" @closeNoviceGuide="closeNoviceGuide">
    </noviceGuide> -->

  </div>
</template>

<script>
import messageBox from "@/common/messageBox.vue";
import editorHeader from "../../../editorTop/index.vue";
import editorTop from "./common/editorTop.vue";
import rightMenu from "./common/rightMenu.vue";
import editorMixin from "./common/mixin";
// import seek from './common/seek.vue';
import editorOperation from "./common/editorOperation.vue";
import postil from "./common/postil.vue";
import termDialog from "./common/termDialog.vue";
import debounce from "lodash.debounce"; // 防抖函数
import { setCursorEnd } from '@/services/common.js';
// import noviceGuide from "../../common/noviceGuide.vue"; //新手引导

let rightClickElement;
export default {
  mixins: [editorMixin],
  data() {
    return {
      targetList: [],
      sourceList: [],
      scroll: "",
      rightMenuShow: false,
      txtList: [], // 复制用的
      isTerm: false,
      isSearch: false,
      inputTxt: "",
      timer: null,
      timer2: null,
      timeOut: null,
      scale_x: "1",
      scale_y: "1",
      targetInput: "",
      dictItemList: "", // 存储查词数据
      loading: "",
      userId: "",
      termHintList: [],
      memoryHintList: [],
      num: "1",
      imgSrc: require("@/assets/imgs/editor/qr_code_bg.png"), // 弹窗title背景图
      mesBox: false,
      tit: "添加术语",
      txt: "是否保存到项目术语库并替换所有未确认句段？",
      queryData: "",
      saveHint: "",
      isWordBox: false,
      words: [],
      resWord: "",
      seekTxt: "",
      seekTxt2: "",
      project: false,
      cutOff: false,
      isSeekBox: false, // 1 = 查找/替换 2 = 查词 3 = 添加术语
      completion: "",
      contextRight: "",
      seekIndex: 0,
      seekNum: 0,
      seekNum2: 0,
      loadinginstace: "",
      mendSentId: "",
      cursor: "", // 光标
      userIdList: [],
      backgroundImg: require("@/assets/imgs/editor/normal_lock.png"),
      RigBoxIf: true,
      RigSwitchVal: false,
      isSplit: 1,
      isBack: true, // 用户回退到那个界面
      progress: 0,
      taskTypeName: "",
      bCb: false,
      splitSourceSent: "",
      splitTargetSent: "",
      myZoom: 1,
      fontSizeInFF: 16,//用于火狐浏览器中字体缩放
      // editorDe: "#cfe8cc", // 编辑器完成的样式
      // editorOff: "#454545", // 编辑器不可编辑的样式
      // editorNo: "#808080", // 编辑器可编辑的样式
      seekOut: "",
      progressTime: null,
      scrollD: "",
      ifRepeatLock: 0, // 是否重复句段锁定 1为锁定
      ifOnlyPreview: false, // 全文不可编辑为1
      state: true,
      type: null,
    };
  },
  computed: {
    isNovice() {
      return this.$store.state.isNovice;
    },
    numOfGuide() {
      return this.$store.state.numOfGuide;
    }
  },
  async created() {
    await this.queryBySentId();
    await this.getWord("1", 1, true);
  },
  components: {
    editorHeader,
    editorTop,
    messageBox,
    rightMenu,
    postil,
    editorOperation,
    termDialog,
    // noviceGuide,
  },
  mounted() {
    this.getUserInfo();
    var that = this;
    // 通过$refs获取dom元素
    let dom = that.$refs.redactBox;
    dom.addEventListener("drop", function (event) {
      // 获取拖拽文本内容
      var text = event.dataTransfer.getData("text");
      if (
        this.value == "" &&
        text.match(/\d/g) &&
        text.match(/\d/g).length == 11
      ) {
        event.preventDefault();
        dom.value = text.replace(/\D/g, "");
        dom.select();
      }
    });
    this.getprogress();
    // 监听这个dom的scroll事件
    var sourceText = document.getElementById("sourceText").clientHeight;
    that.$refs.viewBox2.addEventListener("scroll", this.viewBoxScroll, false);
    that.$refs.viewBox.addEventListener("scroll", this.viewScroll, false);
  },
  beforeDestroy() {
    this.$message.closeAll();
    this.$refs.viewBox2.removeEventListener("scroll", this.viewBoxScroll);
    this.$refs.viewBox.removeEventListener("scroll", this.viewScroll);
    this.loadinginstace.close(); // loading清除
  },
  methods: {
    async getUserInfo() {
      let self = this;
      self.$store.dispatch("layout/userInfo").then(resp => {
        if (!!resp && resp.status === 200 && resp.success) {
          let result = resp.result;
          let companyCode = result.lastSelectCompany.code;
          localStorage.setItem("myUser", JSON.stringify(result));
          localStorage.setItem("userInfo", JSON.stringify(result));
          localStorage.setItem("sourceAppid", result.sourceAppid);
          localStorage.setItem("companyCode", result.lastSelectCompany.code); // 公司编码
          localStorage.setItem("myCompanyCode", result.lastSelectCompany.code); // 公司编码
          this.$store.dispatch('ws/UPDATE_LOGIN_INFO', result);
        }
      });
    },
    // 取消译员任务段落高亮
    interpreterTaskOut() {
      let taskType = this.queryData.taskType;
      this.interpreterTaskDomList.forEach(item => {
        let status = item.getAttribute("status");
        let title = item.getAttribute("title");
        if (
          ((status == 2 && taskType === 1) ||
            (status == 4 && taskType === 2) ||
            (status == 5 && taskType === 3)) &&
          title !== "其他译员任务" &&
          item.isContentEditable
        ) {
          item.style.background = this.editorDe;
        } else {
          item.style.background = "";
        }
      })
    },
    // 译员任务段落高亮
    interpreterTask(uid) {
      this.interpreterTaskDomList = this.$refs.viewBox2.querySelectorAll(`span[uid='${uid}']`);
      this.interpreterTaskDomList.forEach(item => {
        item.style.background = "#DBEEFF"
      })
    },
    // qa用来定位dom
    domFun(row) {
      return this.$refs.viewBox2.querySelector(`span[sid='${row.id}']`);
    },
    // 用来编辑原文
    sourceDomFun(id) {
      return this.$refs.viewBox.querySelector(`span[sid='${id}']`);
    },
    // 夜间模式
    editorThemeStyle(type) {
      const { taskType } = this.queryData
      if (type == "standard") {
        this.bCb = false;
        sessionStorage.setItem("sessionBCb", this.bCb);
        this.editorDe = "#cfe8cc"; //确定块的
        this.editorOff = "rgb(170,170,170)";
        this.editorNo = "#454545";
        this.focusBack = "#e5f1be";
        // 编辑器字体颜色  译文
        let translation = this.$refs.viewBox2;
        let ary = translation.getElementsByTagName("span");
        let arr = Array.from(ary);
        arr.forEach((item) => {
          if (item.getAttribute("type")) {
            if (item.isContentEditable) {
              item.style.color = this.editorNo;
              this.setInsertSty(item);
            } else {
              item.style.color = this.editorOff;
              this.setInsertSty(item, "disabled");
            }
          }

          let status = item.getAttribute("status");
          if (
            ((status == 2 && taskType === 1) ||
              (status == 4 && taskType === 2) ||
              (status == 5 && taskType === 3)) &&
            item.isContentEditable
          ) {
            // status值为 -1删除 0未翻译 1机器翻译 2已编辑 3已完成 4审校
            item.style.background = this.editorDe;
          }
        });
        // 原文
        let sourceText = this.$refs.viewBox;
        let ary1 = sourceText.getElementsByTagName("span");
        let arr1 = Array.from(ary1);
        arr1.forEach((item) => {
          item.style.color = "";
          let status = item.getAttribute("status");
          if (
            (status == 2 && taskType === 1) ||
            (status == 4 && taskType === 2) ||
            (status == 5 && taskType === 3)
          ) {
            // status值为 -1删除 0未翻译 1机器翻译 2已编辑 3已完成 4审校
            item.style.background = this.editorDe;
          }
          if (item.getAttribute("type")) {
            item.style.color = "";
            if (item.isContentEditable) {
              item.style.color = this.editorNo;
            } else {
              item.style.color = this.editorOff;
            }
          }
        });
      } else if (type == "dark") {
        this.bCb = true;
        sessionStorage.setItem("sessionBCb", this.bCb);
        console.log(sessionStorage.sessionBCb);
        this.editorDe = "#50606e"; //确定块的颜色
        this.editorOff = "#696A6D";
        this.editorNo = "#AAABAD";
        this.focusBack = "#405982";
        // 编辑器字体颜色  译文
        let translation = this.$refs.viewBox2;
        let ary = translation.getElementsByTagName("span");
        let arr = Array.from(ary);
        console.log(arr);
        arr.forEach((item) => {
          if (item.getAttribute("type")) {
            if (item.isContentEditable) {
              item.style.color = this.editorNo;
              this.setInsertSty(item);
            } else {
              item.style.color = this.editorOff;
              this.setInsertSty(item, "disabled");
            }
          }
          let status = item.getAttribute("status");
          if (
            ((status == 2 && taskType === 1) ||
              (status == 4 && taskType === 2) ||
              (status == 5 && taskType === 3)) &&
            item.isContentEditable
          ) {
            // status值为 -1删除 0未翻译 1机器翻译 2已编辑 3已完成 4审校
            item.style.background = this.editorDe;
          }
        });
        // 原文
        let sourceText = this.$refs.viewBox;
        let ary1 = sourceText.getElementsByTagName("span");
        let arr1 = Array.from(ary1);
        arr1.forEach((item) => {
          if (item.getAttribute("type")) {
            if (item.isContentEditable) {
              item.style.color = this.editorNo;
            } else {
              item.style.color = this.editorOff;
            }
          }
        });
      }
    },
    // 原文滑动
    viewScroll() {
      let that = this;
      let viewBox = this.$refs.viewBox;
      let htmlHeight = viewBox.clientHeight;
      this.rightMenuShow = false;
      if (viewBox.scrollTop + htmlHeight + 50 > viewBox.scrollHeight) {
        if (!that.timer2) {
          if (that.cutOff) {
            return;
          }
          that.timer2 = setTimeout(function () {
            that.num++;
            that.getWord(that.num, 1);
            that.timer2 = null;
          }, 500);
        }
      }
      if (viewBox.scrollTop < 50 && that.num > 20) {
        that.cutOff = false;
        let page = "";
        if (!that.timeOut) {
          that.timeOut = setTimeout(function () {
            page = that.num - 20;
            that.num--;
            that.getWord(page, 2);
            that.timeOut = null;
          }, 500);
        }
      }
    },
    // 译文滑动
    viewBoxScroll() {
      let that = this;
      this.rightMenuShow = false;
      let viewBox = this.$refs.viewBox,
        viewBox2 = this.$refs.viewBox2;
      let htmlHeight = viewBox2.clientHeight;
      let scrollTopMax1 = viewBox.scrollHeight - viewBox.clientHeight;
      let scrollTopMax2 = viewBox2.scrollHeight - viewBox2.clientHeight;
      let scale = scrollTopMax1 / scrollTopMax2;
      viewBox.scrollTop = scale * viewBox2.scrollTop; // 滚动条改变
      if (viewBox2.scrollTop + htmlHeight + 10 > viewBox2.scrollHeight) {
        if (!that.timer2) {
          if (that.cutOff) {
            return;
          }
          that.timer2 = window.setTimeout(function () {
            that.num++;
            that.getWord(that.num, 1);
            that.timer2 = null;
          }, 1000);
        }
      }
      if (viewBox2.scrollTop < 50 && that.num > 20) {
        that.cutOff = false;
        let page = "";
        if (!that.timeOut) {
          that.timeOut = window.setTimeout(function () {
            page = that.num - 20;
            that.num--;
            that.getWord(page, 2);
            that.timeOut = null;
          }, 500);
        }
      }
    },
    // 重新机翻句段
    anewTranslate() {
      let that = this;
      let sid = rightClickElement.getAttribute("sid");
      if (!sid) {
        return;
      }
      let rigTag = this.$refs.viewBox2.querySelector(`span[sid='${sid}']`);
      if (!rightClickElement.isContentEditable) {
        this.$message.closeAll();
        this.$message({
          message: "不可编辑句段不支持重新机翻",
          type: "warning",
        });
        return;
      }
      this.catReq1Service(
        "/api/v1/file/get_sent_machine_translation",
        {
          sid,
          companyCode: localStorage.myCompanyCode,
          taskType: this.queryData.taskType,
          fileId: that.queryData.fileId,
          taskId: this.queryData.taskId,
        },
        "get"
      ).then(function (response) {
        if (!response.success) {
          return;
        }
        rigTag.innerText = response.result.convertStr;
        that.sentenceShow = false;
        that.changeText(rigTag);
      });
    },
    // 缩小
    sizeNarrow() {
      this.userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
      if (this.userAgent.indexOf("Firefox") > -1) {//判断是否Firefox浏览器
        if (this.fontSizeInFF <= 12) {
          return;
        }
        this.fontSizeInFF = this.fontSizeInFF - 2;
        this.$refs.viewBox2.style.fontSize = this.fontSizeInFF + "px";
        this.$refs.viewBox.style.fontSize = this.fontSizeInFF + "px";
      } else {
        if (this.myZoom < 0.9) {
          return;
        }
        this.myZoom = this.myZoom - 0.2;
        this.$nextTick(() => {
          this.$refs.viewBox2.style.zoom = this.myZoom;
          this.$refs.viewBox.style.zoom = this.myZoom;
        });
      }
    },
    // 放大
    sizeEnlarge() {
      this.userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
      if (this.userAgent.indexOf("Firefox") > -1) {//判断是否Firefox浏览器
        if (this.fontSizeInFF >= 20) {
          return;
        }
        this.fontSizeInFF = this.fontSizeInFF + 2;
        this.$refs.viewBox2.style.fontSize = this.fontSizeInFF + "px";
        this.$refs.viewBox.style.fontSize = this.fontSizeInFF + "px";
      } else {
        if (this.myZoom > 1.1) {
          return;
        }
        this.myZoom = this.myZoom + 0.2;
        this.$nextTick(() => {
          this.$refs.viewBox2.style.zoom = this.myZoom;
          this.$refs.viewBox.style.zoom = this.myZoom;
        });
      }
    },
    // 拆分句段
    splitSentence(e) {
      let that = this;
      if (!rightClickElement.isContentEditable) {
        // 要拆分的句段不能为不可编辑
        this.$message.closeAll();
        this.$message({
          message: "不可编辑句段不支持拆分",
          type: "warning",
        });
        return;
      }
      let sentId = rightClickElement.getAttribute("sid");
      let params = {
        isNewVersion: 1,
        sentId,
        transFileId: this.queryData.fileId,
        transFileSentList: [
          { sourceSent: this.splitSourceSent },
          { sourceSent: this.splitTargetSent },
        ],
      };
      this.catReq1Service("/api/v1/sent/splitTransSent", params, "post").then(
        function (response) {
          if (!response.success) {
            return;
          }
          that.sentenceShow = false;
          let SourceSentData = response.result[0];
          let TargetSentData = response.result[1];
          // 原文部分
          let parentDom = rightClickElement.parentNode;
          let strNode = document.createElement("span"); // 创建一个节点用来放拆分的上一部分
          let strTextNode = document.createTextNode(SourceSentData.sourceSent);
          strNode.appendChild(strTextNode);
          parentDom.insertBefore(strNode, rightClickElement);
          let sourceAttrs = rightClickElement.attributes;
          for (let i = sourceAttrs.length - 1; i >= 0; i--) {
            // 复制属性
            strNode.setAttribute(sourceAttrs[i].name, sourceAttrs[i].value);
          }
          strNode.setAttribute("sourceMd516", SourceSentData.sourceMd516);
          rightClickElement.setAttribute(
            "sourceMd516",
            TargetSentData.sourceMd516
          );
          rightClickElement.setAttribute("sid", TargetSentData.id);
          rightClickElement.innerText = TargetSentData.sourceSent;
          strNode.onclick = function ($event) {
            that.getCursortPosition($event);
          };
          strNode.oninput = function ($event) {
            $event.target.innerText = that.myInnerText;
          };
          strNode.onfocus = function ($event) {
            that.myInnerText = $event.target.innerText;
            that.getCursortPosition($event);
          };
          // 译文部分
          let targetTag = that.$refs.viewBox2.querySelector(
            `span[sid='${sentId}']`
          ); // 创建一个节点用来放拆分的下一部分
          let targetParentDom = targetTag.parentNode;
          let targetStrNode = document.createElement("span"); // 创建一个节点用来放拆分的上一部分
          let targetStrTextNode = document.createTextNode(targetTag.innerText); // SourceSentData.targetSent
          targetStrNode.oninput = function ($event) {
            that.changeText($event.target);
          };
          targetStrNode.onblur = function ($event) {
            that.blurText($event);
          };
          targetStrNode.onfocus = function ($event) {
            that.onFocus($event.target);
          };
          targetStrNode.onkeydown = function ($event) {
            that.enterKey($event);
          };
          targetStrNode.appendChild(targetStrTextNode);
          targetParentDom.insertBefore(targetStrNode, targetTag);
          let attrs = targetTag.attributes;
          for (let i = attrs.length - 1; i >= 0; i--) {
            // 复制属性
            targetStrNode.setAttribute(attrs[i].name, attrs[i].value);
          }
          targetStrNode.setAttribute("sourceMd516", SourceSentData.sourceMd516);
          targetTag.setAttribute("sourceMd516", TargetSentData.sourceMd516);
          targetTag.setAttribute("sid", TargetSentData.id);
          targetStrNode.setAttribute("status", SourceSentData.status);
          targetTag.innerText = TargetSentData.targetSent;
          that.getSentHtmlContent(sentId); // 设置样式
          that.getSentHtmlContent(TargetSentData.id); // 设置样式
          that.$message.closeAll();
          that.$message({
            message: "拆分成功!",
            type: "success",
          });
        }
      );
    },
    // 合并句段
    mergeSentence() {
      let that = this;
      let dom = rightClickElement.nextElementSibling;
      if (!rightClickElement.isContentEditable) {
        // 要合并的句段不能为不可编辑
        this.$message.closeAll();
        this.$message({
          message: "该句段不支持合并",
          type: "warning",
        });
        return;
      }
      let sourceSentId = rightClickElement.getAttribute("sid");
      let source = document.getElementById("sourceText");
      source = source.querySelectorAll(`span[sid]`);
      let targetDom;
      source.forEach((item, index) => {
        if (item === rightClickElement) {
          function dom2(params) {
            if (!source[params + 1]) {
              return;
            }
            if (source[params + 1].innerText === "") {
              dom2(params + 1);
              return;
            }
            targetDom = source[params + 1];
          }

          dom2(index);
        }
      });
      if (!targetDom) {
        return;
      }
      let targetSentId = targetDom.getAttribute("sid");
      this.catReq1Service(
        "/api/v1/sent/mergeTransSent",
        { targetSentId, sourceSentId, transFileId: that.queryData.fileId },
        "post"
      ).then(function (response) {
        if (!response.success) {
          return;
        }
        that.sentenceShow = false;
        // rightClickElement.target.innerText =
        //   rightClickElement.target.innerText + targetDom.innerText;
        rightClickElement.innerText = response.result.sourceSent;
        targetDom.innerText = "";
        targetDom.setAttribute("contenteditable", "false");
        let sourceTag = that.$refs.viewBox2.querySelector(
          `span[sid='${sourceSentId}']`
        );
        let targetTag = that.$refs.viewBox2.querySelector(
          `span[sid='${targetSentId}']`
        );
        that.getSentHtmlContent(sourceSentId);
        // sourceTag.innerText = sourceTag.innerText + targetTag.innerText;
        sourceTag.innerText = response.result.targetSent;
        targetTag.innerText = "";
        targetTag.setAttribute("contenteditable", "false");
        that.$message.closeAll();
        that.$message({
          message: "合并成功!",
          type: "success",
        });
      });
    },
    unlockSentence() {
      if (rightClickElement.isContentEditable) {
        // 要拆分的句段不能为不可编辑
        this.$message.closeAll();
        this.$message({
          message: "句段或已被拆分",
          type: "warning",
        });
        return;
      }
      let sentId = rightClickElement.getAttribute("sid");
      let sourceTag = this.$refs.viewBox.querySelector(`span[sid='${sentId}']`);
      this.unlockSentenceBase(sourceTag, rightClickElement, 1)
    },
    // 获取光标位置
    getCursortPosition(e) {
      let node = this.getNode(e.target);
      var eleP = node.parentNode; //获取父级元素
      var pos = 0;
      pos = this.getDivPosition(node);
      if (node.innerText) {
        // console.log(node.innerText);
        this.splitSourceSent = node.innerText.slice(0, pos);
        this.splitTargetSent = node.innerText.slice(pos);
      }
    },
    //可编辑div获取坐标
    getDivPosition(element) {
      var caretOffset = 0;
      var doc = element.ownerDocument || element.document;
      var win = doc.defaultView || doc.parentWindow;
      var sel;
      if (typeof win.getSelection != "undefined") {
        //谷歌、火狐
        sel = win.getSelection();
        if (sel.rangeCount > 0) {
          //选中的区域
          var range = win.getSelection().getRangeAt(0);
          var preCaretRange = range.cloneRange(); //克隆一个选中区域
          preCaretRange.selectNodeContents(element); //设置选中区域的节点内容为当前节点
          preCaretRange.setEnd(range.endContainer, range.endOffset); //重置选中区域的结束位置
          caretOffset = preCaretRange.toString().length;
        }
      } else if ((sel = doc.selection) && sel.type != "Control") {
        //IE
        var textRange = sel.createRange();
        var preCaretTextRange = doc.body.createTextRange();
        preCaretTextRange.moveToElementText(element);
        preCaretTextRange.setEndPoint("EndToEnd", textRange);
        caretOffset = preCaretTextRange.text.length;
      }
      return caretOffset;
    },
    // 开启编辑器
    codeRigBox() {
      this.RigBoxIf = true;
      this.RigSwitchVal = "true";
      this.$nextTick(() => {
        this.$refs.redactBox.style.width = "calc(100% - 360px)";
        this.$refs.rigContantBox.style.width = "300px";
        this.$refs.rigContantBox.style.marginRight = "20px";
      });
    },
    // 获取译员信息
    getUser() {
      var that = this;
      this.catReq1Service("/api/v1/user/queryByFileId", {
        id: that.queryData.fileId,
      }).then(function (response) {
        if (!response.success) {
          return;
        }
        that.userIdList = response.result;
      });
    },
    seekShow() {
      if (this.isSeekBox === 1) {
        this.isSeekBox = false;
        this.seekTxt = "";
        this.seekTxt2 = "";
        this.actList = [];
      } else {
        this.isSeekBox = 1;
      }
    },
    // 查找 下一个
    seekNext() {
      let domList = document.getElementsByClassName("seekActive");
      //  if (this.seekIndex===0) {
      //    domList[i].style.background = "#555";
      //  }
      if (this.actList.length === 0 || this.actList.length === 1) {
        return;
      }
      let currentBoxList = document.getElementsByClassName("current-box");
      currentBoxList = Array.from(currentBoxList);
      currentBoxList.forEach((item) => {
        item.classList.remove("current-box");
      });
      if (this.seekIndex >= this.actList.length - 1) {
        this.activeFor(this.actList[0]);
        // this.actList[0].style.background = "rgb(163, 217, 241)";
        // this.actList[this.seekIndex].style.background = "yellow";
        this.seekIndex = 0;
        // this.actList[this.seekIndex].tag.scrollIntoView();
        this.seekNum = 1;
        return;
      }
      this.seekIndex++;
      this.seekNum++;
      this.activeFor(this.actList[this.seekIndex]);

      // this.actList[this.seekIndex].tag.scrollIntoView();
      // debugger
      // if (this.seekIndex > 0) {

      //   this.actList[this.seekIndex].style.background = "rgb(163, 217, 241)";
      //   this.actList[this.seekIndex - 1].style.background = "yellow";
      // } else {
      //   this.actList[this.seekIndex].style.background = "rgb(163, 217, 241)";
      // }
    },
    // 查找 上一个
    previous() {
      let domList = document.getElementsByClassName("seekActive");
      let len = this.actList.length;

      if (this.actList.length === 0 || this.actList.length === 1) {
        return;
      }
      let currentBoxList = document.getElementsByClassName("current-box");
      currentBoxList = Array.from(currentBoxList);
      currentBoxList.forEach((item) => {
        item.classList.remove("current-box");
      });
      if (this.seekIndex === 0) {
        // this.actList[len - 1].style.background = "rgb(163, 217, 241)";
        // this.actList[0].style.background = "yellow";
        this.activeFor(this.actList[len - 1]);
        this.seekIndex = len - 1;
        // this.actList[this.seekIndex].scrollIntoView();
        this.seekNum = len;
        return;
      }
      this.seekIndex--;
      // if (this.seekNum<len) {
      this.seekNum--;
      // this.actList[this.seekIndex].scrollIntoView();
      // }
      this.activeFor(this.actList[this.seekIndex]);
      // this.actList[this.seekIndex].style.background = "rgb(163, 217, 241)";
      // this.actList[this.seekIndex + 1].style.background = "yellow";
    },
    //   // 查找
    seekChange() {
      let that = this;
      this.delClassList();
      this.seekNum2 = 0;
      this.seekNum = 0;
      this.seekIndex = 0;
      if (this.seekTxt === "") {
        return;
      }
      let oAt = this.$refs.redactBox;
      let dom = oAt.querySelectorAll(`span[sid]`);
      dom = Array.from(dom);
      let seekTxt = this.seekTxt;
      if (seekTxt.indexOf(".") != -1 || seekTxt.indexOf("?") != -1) {
        let ary = seekTxt.split("");
        for (let i = 0; i < ary.length; i++) {
          if (ary[i] === "." || ary[i] === "?") {
            ary[i] = "\\" + ary[i];
          }
        }
        seekTxt = ary.join("");
      }
      let reg = new RegExp(seekTxt, "ig");
      let nodeList = [];

      function getOf(item, text, ary, len) {
        let index = item.innerText.indexOf(text, len);
        if (index != -1) {
          ary.push({
            start: index,
            end: index + text.length,
            tag: item,
          });
          index = index + text.length;
          return getOf(item, text, ary, index);
        } else {
          return ary;
        }
      }

      for (let i = 0; i < dom.length; i++) {
        const item = dom[i];
        let index = item.innerText.indexOf(this.seekTxt);
        if (index != -1) {
          nodeList.push({
            tag: item,
            indexList: getOf(item, this.seekTxt, [], 0),
          });
        }
      }

      function getNodeObj(tag) {
        let tagObjList = [],
          num = 0;
        let reg = /.{1}/g;
        if (tag.children.length < 1) {
          let nodeHtml = tag.innerText.replace(reg, function (params) {
            return '<span class="span-active">' + params + "</span>";
          });
          tag.innerHTML = nodeHtml;
          return;
        }
        let childNodes = Array.from(tag.childNodes);
        for (let index = childNodes.length - 1; index >= 0; index--) {
          const element = childNodes[index];
          // debugger
          let len = element.innerText.length + num;
          if (
            element.classList.contains("span-active") &&
            element.innerText == ""
          ) {
            tag.removeChild(element);
            return;
          }
          // console.log(element.classList.contains("span-active"));
          if (!element.classList.contains("span-active")) {
            let activeStr = element.innerText.replace(reg, function (params) {
              return '<span class="span-active">' + params + "</span>";
            });
            element.innerHTML = activeStr;
          }
          // if (element.getAttribute("comment")) {
          //   element.setAttribute("cid", that.setCanvasSort(element)); // 设置批注
          // }
          tagObjList.push({
            start: num,
            end: len,
            tag: element,
            tagIndex: index,
          });
          num = len;
        }

        return tagObjList;
      }

      this.actList = [];
      nodeList.forEach((item) => {
        getNodeObj(item.tag);
        this.actList.push(...item.indexList);
        let domList = item.tag.getElementsByClassName("span-active");
        // domList = Array.from(domList);
        item.indexList.forEach((i) => {
          for (let j = i.start; j < i.end; j++) {
            domList[j].classList.add("seekActive");
            // domList[j].style.background = "yellow"
          }
        });
        // let activeList = item.tag.getElementsByClassName("span-active");
      });
      this.$nextTick(() => {
        this.seekNum2 = this.actList.length;
        if (this.seekNum2 === 0) {
          return;
        }
        this.seekNum = 1;
        this.activeFor(this.actList[0]);
        // this.actList.forEach((item,index)=>{
        //   if (item.tag === this.seekNode) {
        //     this.activeFor(item)
        //     this.seekNum = index;
        //   }
        // })
      });
      // dom.getAttribute("sentid")
      let str1 = this.$refs.viewBox2.innerHTML;
      if (!seekTxt) {
        return;
      }
    },
    activeFor(obj) {
      console.log(obj, "///");

      let domList = obj.tag.getElementsByClassName("span-active");
      if (!domList) {
        return;
      }
      for (let j = obj.start; j < obj.end; j++) {
        domList[j].scrollIntoView();
        domList[j].classList.add("current-box");
      }
    },
    // 替换
    onReplace() {
      if (!this.ifSubmit) {
        // 提交任务不可以替换
        this.$message.closeAll();
        this.$message({
          message: "不可修改",
          type: "warning",
        });
        return;
      }
      if (this.actList.length < 1) {
        // 为空时不执行
        return;
      }
      if (this.seekIndex < 0) {
        this.seekIndex = 0;
      }

      let dom = this.actList[this.seekIndex].tag;
      // this.getComments(dom)
      if (dom.isContentEditable && dom.getAttribute("type") === "source") {
        // 只可编辑替换
        return;
      }
      let sonDom = this.actList[this.seekIndex];
      let currentBoxList = document.getElementsByClassName("current-box");
      currentBoxList = Array.from(currentBoxList);
      for (let i = currentBoxList.length - 1; i >= 0; i--) {
        if (i === 0) {
          currentBoxList[0].innerText = this.seekTxt2;
          currentBoxList[0].classList.remove("seekActive");
          currentBoxList[0].classList.remove("current-box");
        } else {
          // currentBoxList[i].parentNode.removeChild(currentBoxList[i])
          currentBoxList[i].innerText = "";
          currentBoxList[i].classList.remove("seekActive");
          currentBoxList[i].classList.remove("current-box");
        }
      }
      this.actList.splice(this.seekIndex, 1);
      // sonDom.style.background = "";
      // sonDom.innerText = this.seekTxt2;
      // sonDom.classList.remove("seekActive");
      dom.setAttribute('cf', "true");
      this.changeText(dom, true);
      this.seekNum2 = this.actList.length;
      if (this.seekNum2 === 0) {
        this.seekNum = 0;
        return;
      }
      this.seekIndex--;
      if (this.seekNum > 1) {
        this.seekNum--;
      }
      if (this.seekNum2 === 1) {
        this.activeFor(this.actList[0]);
        return;
      }
      this.seekNext();
    },
    // 全部替换
    async replaceChange() {
      let that = this;
      if (!this.ifSubmit) {
        // 提交任务不可以替换
        this.$message.closeAll();
        this.$message({
          message: "不可修改",
          type: "warning",
        });
        return;
      }
      console.log(this.actList, "???");
      for (let j = this.actList.length - 1; j >= 0; j--) {
        let item = this.actList[j];
        let tag = item.tag;
        // this.getComments(tag);
        if (
          (tag.getAttribute("contenteditable") === "0" ||
            tag.getAttribute("contenteditable") === this.contentEditableValue) &&
          tag.getAttribute("type") === "target"
        ) {
          let domList = tag.getElementsByClassName("span-active");
          if (domList.length > 1) {
            for (let i = item.end - 1; i >= item.start; i--) {
              if (i === item.start) {
                domList[item.start].innerText = this.seekTxt2;
                domList[item.start].classList.remove("seekActive");
                domList[item.start].classList.remove("current-box");
              } else {
                domList[i].parentNode.removeChild(domList[i]);
              }
              if (tag.innerText === "") {
                tag.innerHTML = "&ensp;";
              }
            }
          }
          this.actList.splice(j, 1);
          await this.changeTextOut(tag);
        }
      }
      // // 获取替换修改句子的html
      // [...new Set(this.updateHtmlIdList)].forEach(item =>
      //     this.getSentHtmlContent(item)
      //   ); //
      // this.updateHtmlIdList = [];
      // // 重新查找
      // let seekDebounce = debounce(that.seekChange, 500)
      // seekDebounce();
    },
    // 修改防抖
    async changeTextOut(event) {
      let that = this;
      if (event === this.ev) {
        clearInterval(this.updateTime);
      }
      this.ev = event;
      this.updateTime = await window.setTimeout(async () => {
        // if (this.ev && this.ev.innerText === event.innerText) {
        //   return
        // }
        event.setAttribute('cf', "true");
        await that.changeText(event, true);
        let seekDebounce = debounce(that.seekChange, 500);
        seekDebounce();
      }, 50);
    },
    // 提交任务
    submit() {
      var that = this;
      this.loadinginstace = this.$loading({ fullscreen: true });
      this.catReq1Service("/api/v1/fileTask/finishTask", {
        id: that.queryData.fileId,
        taskType: that.queryData.taskType,
        taskId: this.queryData.taskId,
      }).then(function (response) {
        if (!response.success) {
          that.loadinginstace.close(); // loading清除
          return;
        }
        if (response.resultCode === "1") {
          that.ifOnlyPreview = false;
          that.$message.closeAll();
          that.$message({
            message: "提交任务成功",
            type: "success",
          });
          that.isSeekBox == 5 || that.isSeekBox == 4
            ? (that.isSeekBox = "")
            : "";
          that.isAddPostil = false;
          // that.isUpdatePostil = false;
          that.getprogress();
          let sourceText = document.getElementById("sourceText");
          let translation = document.getElementById("translation");
          let sourceAry = sourceText.getElementsByTagName("span");
          let translationAry = translation.getElementsByTagName("span");
          setTimeout(() => {
            translationAry = Array.from(translationAry);
            sourceAry = Array.from(sourceAry);
            sourceAry.forEach((item) => {
              item.setAttribute("contenteditable", "false");
            });
            translationAry.forEach((item) => {
              if (item.getAttribute("contenteditable")) {
                item.setAttribute("contenteditable", "false");
                item.style.color = that.editorOff;
                item.style.background = "";
                item.style.backgroundColor = "";
              }
            });
            that.loadinginstace.close(); // loading清除
          }, 10);
          that.checkTaskStatus();
        }
      });
    },
    //打回重译
    reTranslate() {
      console.log("已打回")
      let that = this;
      that.ifOnlyPreview = false;
      let sourceText = document.getElementById("sourceText");
      let translation = document.getElementById("translation");
      let sourceAry = sourceText.getElementsByTagName("span");
      let translationAry = translation.getElementsByTagName("span");
      setTimeout(() => {
        translationAry = Array.from(translationAry);
        sourceAry = Array.from(sourceAry);
        sourceAry.forEach((item) => {
          item.setAttribute("contenteditable", "false");
        });
        translationAry.forEach((item) => {
          if (item.getAttribute("contenteditable")) {
            item.setAttribute("contenteditable", "false");
            item.style.color = that.editorOff;
            item.style.background = "";
            item.style.backgroundColor = "";
          }
        });
      }, 10);
    },
    getHint(e, isShow) {
      const node = this.getNode(e.target);
      if (node.getAttribute("type") === "target") {
        this.isSeekBox = false;
      }
      rightClickElement = node;
      this.isFunBut(e, isShow);
      let acticeClass = node.getAttribute("sid");
      // !isShow ? this.sourceSid = acticeClass : '';
      if (!acticeClass) {
        return;
      }
      this.sid = acticeClass;
      let lefTag = this.$refs.viewBox.querySelector(
        `span[sid='${acticeClass}']`
      );

      this.getmemory(lefTag.innerText, "", !isShow);
      this.getTerm(lefTag.innerText);

      // 实时对照
      if (this.contrastStatus) {
        this.contrastTag.innerHTML = this.contrastTag.innerText;
      }
      if (isShow && e.target.isContentEditable) {
        let range = window.getSelection().getRangeAt(0);
        if (this.startOffset !== range.startOffset) {
          this.contrastDebounce(lefTag, e.target);
        }
      }
    },
    getprogress() {
      let urlInfo = this.$store.getters['editor/getUrlInfo'];
      if (urlInfo.type === "task" || urlInfo.type === "school") {
        let data = Object();
        Reflect.set(data, 'id', (urlInfo.fileId));
        Reflect.set(data, 'fileId', (urlInfo.fileId));
        Reflect.set(data, 'taskId', (urlInfo.taskId));
        Reflect.set(data, 'taskType', (urlInfo.taskType));
        this.$store.dispatch('editor/getTaskProgress', data);
      } else {
        this.$store.dispatch("editor/getFileInfo", { id: urlInfo.fileId })
      }
    },
    // 自定义右键菜单
    oncontextmenu(e, isShow) {
      const node = this.getNode(e.target);
      this.sid = node.getAttribute("sid");
      rightClickElement = node;
      this.isFunBut(e, isShow);
      e = e || window.event;
      window.event.returnValue = false;
      this.rightMenuShow = true;
      let rm = this.$refs.rightMenu.$el;
      //2.设置菜单的位置等于鼠标的坐标
      //判断：如果鼠标的位置+菜单的宽度>网页的宽度，那么就改为右边定位
      //鼠标坐标
      let mx = e.clientX;
      let my = e.clientY;
      //菜单宽度
      this.$nextTick(() => {
        let rmWidth = parseInt(rm.clientWidth);
        let rmHeight = parseInt(rm.clientHeight);
        //网页的宽度(高度用同样的方法解决)
        let pageWidth = document.documentElement.clientWidth;
        let pageHeight = document.documentElement.clientHeight;
        if (mx + rmWidth + 10 < pageWidth) {
          rm.style.left = mx + 10 + "px";
        } else {
          rm.style.left = mx - rmWidth - 10 + "px";
        }
        if (my + rmHeight + 10 < pageHeight) {
          rm.style.top = my + 10 + "px";
        } else {
          rm.style.top = my - rmHeight - 10 + "px";
        }
        //3.显示右键菜单
        setTimeout(() => {
          this.rightMenuShow = true;
        }, 10);
        //阻止默认的右键菜单显示
        return false;
      });
    },
    // 选中
    pitchOn(e, type) {
      var event = window.event || e;
      var target = event.srcElement ? event.srcElement : event.target;
      if (
        /input|textarea/i.test(target.tagName) &&
        /firefox/i.test(navigator.userAgent)
      ) {
        //Firefox在文本框内选择文字
        var staIndex = target.selectionStart;
        var endIndex = target.selectionEnd;
        if (staIndex != endIndex) {
          var sText = target.value.substring(staIndex, endIndex);
          this.tanchu(sText, target, event, type);
        }
      } else {
        //获取选中文字
        var sText =
          document.selection == undefined
            ? document.getSelection().toString()
            : document.selection.createRange().text;
        if (sText != "") {
          //将参数传入回调函数fn
          this.tanchu(sText, target, event, type);
        }
      }
    },
    // 选中文字
    tanchu(txt, tar, event, type) {
      if (type) {
        this.targetInput = txt;
      } else {
        this.inputTxt = txt;
      }
      this.seekTxt = txt;
      if (this.isSeekBox === 1) {
        this.seekChange();
      }
      this.txtList.push(txt);
      if (this.txtList.length > 4) {
        this.txtList.shift();
      }
    },
    // 获取文档
    async getWord(data, type, isTop, isScroll) {
      // type=1 滚动条向下 type=2 滚动条向上 一页展示10个页码 isTop 自动加载的
      var that = this;
      let marker;
      let taskType = that.queryData.taskType;
      if (that.queryData.transStatus === 2) {
        // 区分进入口 项目&任务
        marker = 2; // 项目
      } else {
        marker = 1;
      }
      if (that.isScroll) { // isScroll自動加載後300毫秒不可以觸發滾動
        that.num--;
        return
      }
      const response = await this.catReq1Service(
        `/api/v1/file/load_edit_file`,
        {
          fileId: that.queryData.fileId,
          partIndex: data,
          marker,
          taskType: taskType,
          showComment: false,
          taskId: this.queryData.taskId,
          comparedHighlight: this.isRecord ? 1 : 0,
          showTerm: false,
        },
        "get"
      );
      if (!response.success) {
        return;
      }
      if (that.cutOff) {
        return;
      }
      const result = response.result;
      let num = 5,
        ifOnlyPreview = result.ifOnlyPreview;
      if (marker === 2) {
        // 项目下不可编辑则不能添加术语
        that.ifOnlyPreview = !ifOnlyPreview;
      } else {
        // 任务下不可编辑则不能添加术语，可编辑：在翻译状态下可以添加，审校等不可
        that.ifOnlyPreview = ifOnlyPreview
          ? !ifOnlyPreview
          : that.queryData.taskType < 2
            ? !ifOnlyPreview
            : false;

      }
      that.ifRepeatLock = result.ifRepeatLock;
      // const reg = /<style type="text\/css">([\s\S]*)<\/style>/i;
      let sourceStr = result.sourceStr;
      let convertStr = result.convertStr;
      if (type === 1 && result.sourceStr) {
        that.endIndex = data;
        that.sourceList.push({
          data: convertStr,
        });
        that.targetList.push({
          data: sourceStr,
          startSectionIndex: result.startSectionIndex,
          endSectionIndex: result.endSectionIndex,
        });
        if (that.sourceList.length > 20) {
          that.sourceList.shift();
          that.targetList.shift();
        }
      } else if (type === 2 && result.sourceStr) {
        that.sourceList.unshift({
          data: convertStr,
        });
        that.targetList.unshift({
          data: sourceStr,
          startSectionIndex: result.startSectionIndex,
          endSectionIndex: result.endSectionIndex,
        });
        if (that.sourceList.length > 20) {
          that.endIndex = that.endIndex--;
          that.sourceList.pop();
          that.targetList.pop();
        }
      }
      if (marker === 1 && result.convertStr) {
        // 自动加载到自己的任务
        let uidStr;
        switch (taskType) {
          case 2:
            uidStr = `reviserid="${that.queryData.userId}"`
            break;
          case 3:
            uidStr = `secondreviserid="${that.queryData.userId}"`
            break;
          default:
            uidStr = `uid="${that.queryData.userId}"`
            break;
        }

        if (result.sourceStr.indexOf(uidStr) === -1 && isTop) {
          that.num++;
          that.getWord(that.num, 1, true);
          return
        } else if (isTop) {
          setTimeout(async () => {
            let dom = this.$refs.viewBox2.querySelector(`span[${uidStr}]`);
            await dom.scrollIntoView() // 自动加载的要跳转
            that.loadinginstace.close(); // loading清除
            that.isScroll = true;
            setTimeout(() => {
              that.isScroll = false;
            }, 2000);
          }, 500);
        }
      }
      let sourceText = document.getElementById("sourceText");
      let translation = document.getElementById("translation");
      let sourceAry = sourceText.getElementsByTagName("span");
      let targetAry = translation.getElementsByTagName("span");
      await that.$nextTick(async () => {
        sourceAry = Array.from(sourceAry).filter((item) =>
          item.getAttribute("type")
        );
        sourceAry.forEach((item) => {
          item.style.color = that.editorNo;
          item.style.display = "inline-block";
          item.style.outline = "none";
          item.style.whiteSpace = "normal";
          item.style.overflowWrap = "break-word";
          item.style.width = "100%";
          // console.log(item.style,"item.styleitem.style");
          // item.style.textIndent = "0px"
          // that.setTermSty(item) // 设置术语样式
          item.onclick = function ($event) {
            that.getCursortPosition($event);
          };

          if (
            item.getAttribute("uid") &&
            item.getAttribute("uid") !== that.queryData.userId + "" &&
            marker === 1 && taskType === 1
          ) {
            item.setAttribute("editable", "false");
          } else if (
            item.getAttribute("reviserid") &&
            item.getAttribute("reviserid") !== that.queryData.userId + "" &&
            marker === 1 && taskType === 2
          ) {
            item.setAttribute("editable", "false");
          } else if (
            item.getAttribute("secondreviserid") &&
            item.getAttribute("secondreviserid") !== that.queryData.userId + "" &&
            marker === 1 && taskType === 3
          ) {
            item.setAttribute("editable", "false");
          }
          //解锁的支持编辑
          if (item.getAttribute("uk") !== "1" && item.getAttribute("rf") > 0 && that.ifRepeatLock) {
            // 锁定重复句段
            item.setAttribute("editable", "false");
          } else if (item.getAttribute("uk") !== "1" && item.getAttribute("rp") > 0 && that.ifRepeatLock) {
            item.setAttribute("editable", "false");
          }
          if (item.getAttribute("editable") === "true") {
            item.style.color = that.editorNo;
            item.setAttribute("contenteditable", that.contentEditableValue);
          } else {
            item.style.color = that.editorOff;
          }
          if (item.getAttribute("sourcemd516") === " ") {
            item.setAttribute("contenteditable", "false");
          }
          item.oninput = function ($event) {
            if ($event.target.innerText !== that.myInnerText) {
              $event.target.innerText = that.myInnerText;
            }
          };
          item.onfocus = function ($event) {
            that.myInnerText = $event.target.innerText;
          };
        });

        targetAry = Array.from(targetAry).filter((item) =>
          item.getAttribute("type")
        );
        if (!localStorage.myFontSize) {
          localStorage.setItem("myFontSize", 1);
        }
        targetAry.forEach((item) => {
          let parentDom = item.parentNode;
          parentDom.style.position = "relative";
          that.setPostilId(item);

          item.style.display = "inline-block";
          item.style.fontFamily = "微软雅黑";
          item.style.fontSize
            ? (item.style.zoom = localStorage.myFontSize)
            : "";
          item.style.whiteSpace = "normal";
          item.style.overflowWrap = "break-word";
          item.style.width = "100%";
          if (
            item.getAttribute("uid") &&
            item.getAttribute("uid") !== that.queryData.userId + "" &&
            marker === 1 && taskType === 1
          ) {
            item.setAttribute("title", "其他译员任务");
          } else if (
            item.getAttribute("reviserid") &&
            item.getAttribute("reviserid") !== that.queryData.userId + "" &&
            marker === 1 && taskType === 2
          ) {
            item.setAttribute("title", "其他审校任务");
          } else if (
            item.getAttribute("secondreviserid") &&
            item.getAttribute("secondreviserid") !== that.queryData.userId + "" &&
            marker === 1 && taskType === 3
          ) {
            item.setAttribute("title", "其他复审任务");
          }
          //解锁的，支持编辑
          if (item.getAttribute("uk") !== "1" && item.getAttribute("rf") > 0 && this.ifRepeatLock) {
            // 锁定重复句段
            item.setAttribute("contenteditable", "false");
            item.setAttribute("title", "文件内重复句段锁定");
          } else if (item.getAttribute("uk") !== "1" && item.getAttribute("rp") > 0 && this.ifRepeatLock) {
            item.setAttribute("contenteditable", "false");
            item.setAttribute("title", "项目内跨文件重复句段锁定");
          }
          if (item.innerText === "") {
            item.setAttribute("contenteditable", "false");
          }
          if (item.getAttribute('contenteditable') === 'plaintext-only') {
            item.setAttribute('contenteditable', that.contentEditableValue)
          }
          if (item.getAttribute("contenteditable") === that.contentEditableValue) {
            // that.setTermSty(item) // 设置术语样式
            that.setInsertSty(item); // 设置新增文本样式
            let status = Number(item.getAttribute("status"));
            if (
              (status === 2 && taskType === 1) ||
              (status === 4 && taskType === 2) ||
              (status === 5 && taskType === 3)
            ) {
              // status值为 -1删除 0未翻译 1机器翻译 2已编辑 3已完成 4审校 5复审
              item.style.background = that.editorDe;
            }
            item.onkeydown = function ($event) {
              $event.target.setAttribute('cf', 'true')
              that.enterKey($event);
            };
            item.oninput = function ($event) {
              $event.target.setAttribute('cf', 'true')
              that.changeText($event.target, true);
            };
            item.onblur = function ($event) {
              that.blurText($event);
            };
            item.onfocus = function ($event) {
              that.onFocus($event.target);
            };
            item.style.color = that.editorNo;
            item.style.outline = "none";
          } else {
            item.style.color = that.editorOff;
            that.setInsertSty(item, "disabled");
          }
        });

        that.loadinginstace.close(); // loading清除
      });

      that.$nextTick(() => {
        if (result.convertStr === "" && result.sourceStr === "") {
          that.cutOff = true;
        }
        // 避免加载一段未出现滚动条
        if (that.hasScrollbar(that.$refs.viewBox2)) {
          num = that.$refs.viewBox2.scrollTop;
          if (that.scrollD > that.$refs.viewBox2.scrollTop) {
            num = that.$refs.viewBox2.scrollTop;
          }
          that.scrollD = that.$refs.viewBox2.scrollTop;
        }
        // that.$refs.viewBox2.scrollTop = num;
        if (!that.hasScrollbar(that.$refs.viewBox2) && result.convertStr) {
          that.num++;
          that.getWord(that.num, 1, true);
        }
      });
    },

    css1(t, s) {
      s = document.createElement("style");
      s.innerText = t;
      document.body.appendChild(s);
    },
    //  单词补全
    AutoComple(e) {
      if (this.queryData.targetLang != "en") {
        return;
      }
      if (e.data === null || e.data === " ") {
        return;
      }
      let sentId = Number(e.target.getAttribute("sId"));
      this.mendSentId = sentId;
      let lefTag = this.$refs.viewBox.querySelector(`span[sid='${sentId}']`);
      let rigTag = this.$refs.viewBox2.querySelector(`span[sid='${sentId}']`);
      this.AutoCompleMixin(rigTag, lefTag.innerText, "span");
    },
    // 回车确认
    enterKey(e) {
      e = e || window.event;
      let k = e.keyCode || e.which;
      // let taskType = this.queryData.taskType;
      let sentId = Number(e.target.getAttribute("sId"));
      let lefTag = this.$refs.viewBox.querySelector(`span[sid='${sentId}']`);
      if (k === 13) {
        e.returnValue = false;
        let isCommitVersion = 1
        this.type = "enter";
        this.changeText(e.target, false, true, isCommitVersion);
        this.$nextTick(() => {
          lefTag.bor = 0;
          e.target.bor = 0;
          lefTag.style.backgroundColor = "";
          e.target.style.backgroundColor = this.editorDe;
        });
        let oAt = this.$refs.viewBox2;
        let dom = oAt.querySelectorAll(`span[sid]`);
        dom.forEach((item, index) => {
          if (item.getAttribute("sId") == sentId && dom[index + 1]) {
            dom[index + 1].focus();
          }
        });
      } else {
        // 实时对照
        if (this.contrastStatus) {
          this.contrastTag.innerHTML = this.contrastTag.innerText;
        }
        if (e.target.isContentEditable) {
          let range = window.getSelection().getRangeAt(0);
          if (this.startOffset !== range.startOffset) {
            this.contrastDebounce(lefTag, e.target);
          }
        }
      }
    },
    // 聚焦事件
    async onFocus(target) {
      // const top = this.$refs.viewBox2.scrollTop
      if (!target.isContentEditable) {
        this.sentenceShow = false;
      }
      if ((target.getAttribute("rf") > 0 || target.getAttribute("rp") > 0) && this.ifRepeatLock) {
        this.sentenceShow = false;
      }
      if (target.getAttribute("type") === "source") {
        this.typeShow = true;
        this.sid = target.getAttribute("sid");
      } else {
        this.typeShow = false;
        this.writingSpeed(); // 写作时间
      }
      let activeClass = target.getAttribute("sid");
      this.interpreteruid = target.getAttribute("uid");
      let pid = target.getAttribute("pid");
      pid ? (this.isAddPostil = false) : (this.isAddPostil = true);
      let pos = target.getBoundingClientRect();
      const top = this.$refs.viewBox2.scrollTop;
      let postilDom = document.getElementById("postilBox");
      this.postilTarget = {
        txt: target.innerText,
        sid: activeClass,
        tag: target,
        // butTag:target,
      };
      postilDom.style.top = pos.y + top - 150 + "px";
      let that = this;
      let box;
      this.$nextTick(() => {
        box = this.$refs.viewBox;
        if (!activeClass) {
          return;
        }
        let lefTag = this.$refs.viewBox.querySelector(
          `span[sid='${activeClass}']`
        );
        // if (this.contrastStatus) {
        //   this.contrastTag.innerHTML = this.contrastTag.innerText
        // }
        this.lefTagText = lefTag.innerText;
        let rigTag = this.$refs.viewBox2.querySelector(
          `span[sid='${activeClass}']`
        );
        lefTag.bor = 1;
        rigTag.bor = 1;
        lefTag.style.background = that.focusBack;
        rigTag.style.background = that.focusBack;
      });
    },
    // 写作时间
    writingSpeed(isClear) {
      if (isClear) {
        this.oldTime = null;
        return
      }
      setTimeout(() => {
        this.oldTime = new Date();
      }, 110);
    },
    // 失焦
    async blurText(e) {
      let event = e.target
      let relatedTarget = e.relatedTarget
      if (relatedTarget && ['revokeBtn', 'recoveryBtn'].includes(relatedTarget.id)) {
        setCursorEnd(event)
        return false
      }
      let that = this;
      // 获取所有span
      this.interpreteruid = "";
      let sentId = Number(event.getAttribute("sid"));
      let status = Number(event.getAttribute("status"));
      let taskType = this.queryData.taskType;
      that.isWordBox = false;
      let lefTag = this.$refs.viewBox.querySelector(`span[sid='${sentId}']`);
      let rigTag = this.$refs.viewBox2.querySelector(`span[sid='${sentId}']`);
      if (this.contrastStatus) {
        lefTag.innerText = this.lefTagText;
        this.contrastStatus = false;
      }
      lefTag.bor = 0;
      rigTag.bor = 0;
      lefTag.style.backgroundColor = "";
      if (
        (status === 2 && taskType === 1) ||
        (status === 4 && taskType === 2) ||
        (status === 5 && taskType === 3)
      ) {
        rigTag.style.backgroundColor = that.editorDe;
      } else {
        rigTag.style.backgroundColor = "";
      }
      // console.log(this.type, 'this.type', this.type !== 'enter');
      if (this.type !== 'enter') {
        await this.changeText(event, false, true);
      }
    },
    // 修改
    async changeText(event, updateHtml, immediately = false, isCommitVersion = 0) {
      // console.log(isCommitVersion, 'isCommitVersion');
      // 获取所有span
      let that = this;
      if (event === this.ev) {
        clearInterval(this.updateTime);
      }
      this.ev = event;
      let sentId = Number(event.getAttribute("sid"));
      let status = Number(event.getAttribute("status"));
      let taskType = this.queryData.taskType;
      that.isWordBox = false;
      this.updateTime = window.setTimeout(() => {
        if (event.innerText === "") {
          event.innerHTML = "&nbsp;";
        } else if (event.innerText === "/n") {
          event.innerHTML = "&nbsp;";
        }
        //有更改标记，才更新。
        if (event.getAttribute('cf') === "true") {
          event.setAttribute('cfg', "true");
          that.saveHint = "正在自动保存...";
          let timeOut = 3000;
          if (immediately) {
            timeOut = 100
          }
          let costTime = that.oldTime ? (new Date() - that.oldTime - timeOut) / 1000 : undefined;
          if (costTime <= 1) {
            costTime = 1;
          } else {
            Math.round(costTime)
          }
          let params = {
            isSaveVersion: 1,
            isCommitVersion,
            isNewVersion: 1,
            sentId,
            fileId: that.queryData.fileId,
            content: event.innerText,
            companyCode: localStorage.myCompanyCode,
            taskType: taskType,
            status,
            taskId: that.queryData.taskId,
            costTime
          };
          this.catReq1Service("/api/v1/file/updateFileSent", params).then(function (response) {
            if (!response.success) {
              return;
            }
            // this.type = null;
            that.writingSpeed();
            event.removeAttribute('cf');
            that.saveHint = "自动保存成功！";
            that.state = false;
            setTimeout(() => {
              that.saveHint = "";
            }, 500);
            if (taskType === 1) {
              event.setAttribute("status", "2"); // 成功把状态改为2_翻译
            } else if (taskType === 2) {
              event.setAttribute("status", "4"); // 成功把状态改为4_审校
            } else {
              event.setAttribute("status", "5"); // 成功把状态改为4_复审
            }
            event.style.backgroundColor = that.editorDe;
            let translation = document.getElementById("translation");
            let divNode = translation.getElementsByTagName("span");
            that.$nextTick(() => {
              for (let i of divNode) {
                //便利所有div
                if (
                  i.getAttribute("title") ===
                  ("文件内重复句段锁定" || "项目内跨文件重复句段锁定") &&
                  i.getAttribute("sourceMd516") ===
                  event.getAttribute("sourceMd516")
                ) {
                  i.innerHTML = event.innerText; // 修改相同句段的内容
                }
              }
            });
            if (!updateHtml && event.getAttribute('cfg') === 'true') {
              that.getSentHtmlContent(sentId); // 获取修改后样式
              event.removeAttribute("cfg")
            } else {
              that.updateHtmlIdList.push(sentId); // 替换后样式不立即更新
            }
            clearTimeout(that.progressTime);
            that.progressTime = window.setTimeout(() => {
              that.getprogress();
            }, 10000);
            this.type = null;
          }).catch(function (error) {
            that.saveHint = "自动保存失败！";
            setTimeout(() => {
              that.saveHint = "";
            }, 500);
          }).finally(() => {
            that.state = true
          });
        } else {
          if (!updateHtml && event.getAttribute('cfg') === 'true') {
            that.getSentHtmlContent(sentId); // 获取修改后样式
            event.removeAttribute("cfg")
          } else {
            that.updateHtmlIdList.push(sentId); // 替换后样式不立即更新
          }
          clearTimeout(that.progressTime);
          that.progressTime = window.setTimeout(() => {
            that.getprogress();
          }, 10000);

        }
      }, immediately ? 100 : 3000);
    },
    // 鼠标滑出
    styleOut(e) {
      let that = this;
      this.$nextTick(() => {
        let tar = this.getNode(e.target);
        let acticeClass = tar.getAttribute("sid");
        if (!acticeClass) {
          return;
        }
        let lefTag = this.$refs.viewBox.querySelector(
          `span[sid='${acticeClass}']`
        );
        let rigTag = this.$refs.viewBox2.querySelector(
          `span[sid='${acticeClass}']`
        );
        let status = rigTag.getAttribute("status");
        let title = rigTag.getAttribute("title");
        let taskType = this.queryData.taskType;
        let contenteditable =
          rigTag.getAttribute("contenteditable") === that.contentEditableValue;
        if (lefTag.bor === 1) {
          // 用来区分是否处于编辑
          lefTag.style.background = that.focusBack;
          rigTag.style.background = that.focusBack;
        } else if (
          ((status == 2 && taskType === 1) ||
            (status == 4 && taskType === 2) ||
            (status == 5 && taskType === 3)) &&
          title !== "其他译员任务" &&
          contenteditable
        ) {
          lefTag.style.background = "";
          rigTag.style.background = that.editorDe;
        } else {
          lefTag.style.background = "";
          rigTag.style.background = "";
        }
      });
    },
    // 鼠标划入
    styleOver(e) {
      let that = this;
      let box;
      this.$nextTick(() => {
        document.execCommand("unlink");
        box = this.$refs.viewBox;
        let tar = this.getNode(e.target);
        let acticeClass = tar.getAttribute("sid");
        if (!acticeClass) {
          return;
        }
        let lefTag = this.$refs.viewBox.querySelector(
          `span[sid='${acticeClass}']`
        );
        let rigTag = this.$refs.viewBox2.querySelector(
          `span[sid='${acticeClass}']`
        );
        var dome = redactBox.getAttribute(acticeClass);
        lefTag.style.background = that.bCb ? "#838eb4" : "#ECF2D8";
        rigTag.style.background = that.bCb ? "#838eb4" : "#ECF2D8";
      });
    },
    //关闭新手引导
    async closeNoviceGuide(index) {
      this.$store.commit("setIsNovice", false);
    }
  },
};
</script>


<style lang="less">
.styActive {
  border: 1px solid rgb(234, 177, 39);
  box-shadow: rgba(152, 136, 120, 0.4) 0px 0px 5px 0px;
  border-radius: 3px;
  background: #f6f6f2;
  word-wrap: break-word;
  // width: 100%;
}

#redactBox {
  .seekActive {
    background: yellow;
  }

  .current-box {
    background: rgb(163, 217, 241);
  }
}

#translation {
  .right-box-main {
    line-height: 26px;
  }

  .postilBut {
    background: url("~@/assets/imgs/editor/ckbz_normal.png") no-repeat;
    height: 18px;
    width: 18px;
    display: inline-block;
    position: absolute;
    right: -28px;
    top: 0px;
    cursor: pointer;
  }

  .postilBut:active {
    background: url("~@/assets/imgs/editor/ckbz_press.png") no-repeat;
  }
}

#sourceText {
  .lef-box-main {
    line-height: 26px;
  }
}

.backColorB {
  background: rgba(33, 44, 50, 1) !important;
  .main-box {
    .styActive {
      background: #535d78;
    }
  }
  #translation {
    .postilBut {
      background: url("~@/assets/imgs/editor/yj_ckbz_normal.png") no-repeat;
    }
  }
}
</style>
<style lang="less" scoped>
.backColorB {
  background: rgba(33, 44, 50, 1) !important;

  #sourceText {
    background: rgba(48, 51, 60, 1) !important;
    .tit {
      color: #c6c6c6 !important;
    }

    div {
      span {
        color: rgb(170, 171, 173) !important;
      }
    }
  }

  #translation {
    background: rgba(48, 51, 60, 1) !important;
    color: #c6c6c6 !important;

    .tit {
      color: #c6c6c6 !important;
    }
  }

  .progressBox {
    color: white !important;
  }

  /deep/ .el-progress-bar__outer {
    background-color: #4d515f !important;
  }

  /deep/ .el-progress-bar__inner {
    background: #507383 !important;
  }

  /*下拉框颜色*/

  /deep/ .el-popper {
    /deep/ .el-scrollbar {
      /deep/ .el-scrollbar__view {
        /deep/ .el-select-dropdown__item {
          background: #507383 !important;
        }

        background: #507383 !important;
      }
    }
  }

  .operationBox {
    background: rgba(48, 51, 60, 1) !important;
    color: #c6c6c6 !important;

    h3 {
      background: #507383 !important;
    }

    h4 {
      color: #c6c6c6;
    }

    h5 {
      color: #c6c6c6;
    }

    .find {
      div {
        input {
          background: #507383 !important;
          border: none !important;
          color: white !important;
        }

        input::-webkit-input-placeholder {
          color: white !important;
        }
      }

      .findBox {
        border: 1px solid #507383 !important;

        li {
          color: white !important;
        }
      }
    }

    .addTerm {
      input {
        background: #507383 !important;
        border: none !important;
        color: white !important;
      }

      input::-webkit-input-placeholder {
        color: white !important;
      }
    }

    button {
      background: #507383 !important;
      color: white !important;
      border: none !important;
    }

    button:hover {
      background: #405964 !important;
    }

    button:active {
      background: #2c4753 !important;
    }
  }

  /deep/ .el-select {
    /deep/ .el-input__inner {
      background: #507383 !important;
      border: none !important;
      color: white !important;
    }
  }

  /deep/ .el-button {
    background: #507383 !important;
    border: none !important;
    color: white !important;
  }
}

.mystyle {
  box-shadow: 2px 5px 2px 0px rgba(102, 102, 102, 0.5) !important;
  font-size: 18px;
}

.main {
  height: 100%;
  background: #f1f5ff;
  .editor-header-top {
    height: 60px;
    // background: rgba(255, 255, 255, 1);
  }

  header {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 9px 0px rgba(235, 246, 241, 1);
    height: 50px;

    .top_l {
      float: left;
      display: flex;
      align-items: center;
      height: 100%;

      .saveHint {
        margin-left: 20px;
      }

      button {
        float: left;
        width: 48px;
        height: 30px;
        background: rgba(102, 102, 102, 1);
        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
        border-radius: 2px;
        color: white;
        font-size: 18px;
        margin: 0 20px;
      }

      p {
        max-width: 600px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .top_r {
      float: right;
      line-height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;

      /deep/ .el-input {
        width: 160px;
      }

      .el-select {
        margin-right: 20px;

        .el-input {
          width: 160px;
        }
      }

      img {
        border-radius: 50%;
      }

      input {
        height: 36px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(186, 185, 185, 1);
        border-radius: 2px;
      }

      a {
        margin-right: 40px;

        img {
          width: 40px;
          height: 40px;
          vertical-align: middle;
        }

        span {
          margin-left: 20px;
          width: 47px;
          height: 11px;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
      }

      .out {
        width: 18px;
        height: 20px;
        margin-right: 60px;
        background: url("~@/assets/imgs/project/sign_out_normal.png");
      }

      .out :hover {
        background: url("~@/assets/imgs/project/sign_outhover.png");
      }

      .out :active {
        background: url("~@/assets/imgs/project/sign_out_press.png");
      }
    }
  }

  .el-select {
    float: left;
    margin-left: 30px;
  }

  /deep/ .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
}

/deep/ .cat-trans {
  width: calc(100% - 360px);
  margin-left: 20px;
  float: left;
  height: 100%;
  position: relative;
  z-index: 5;
  word-wrap: break-word;

  a {
    display: inline-block;
  }
}

.rigContantBox {
  float: right;
  width: 300px;
  height: 100%;
  margin-right: 20px;
  position: relative;

  .riBoxSw {
    position: absolute;
    top: 50%;
    height: 50px;
    width: 13px;
    left: -20px;
    z-index: 30;
    font-size: 24px;
    transform: translateY(-50%);
    cursor: pointer;
  }

  .icon-left {
    background: url("~@/assets/imgs/editor/zhankai_normal.png") no-repeat;
  }

  .icon-left:active {
    background: url("~@/assets/imgs/editor/zhankai_press.png") no-repeat;
  }

  .icon-right {
    background: url("~@/assets/imgs/editor/shouqi_normal.png") no-repeat;
  }

  .icon-right:active {
    background: url("~@/assets/imgs/editor/shouqi_press.png") no-repeat;
  }
}

.operationBox {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #fff;
  padding: 5px 0;
  box-sizing: border-box;

  .termTit {
    margin-left: 20px;
    width: 80%;
  }

  .operation {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    .addTerm {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      justify-content: center;
      padding: 0 20px;

      .sourceInput {
        width: 280px;
        height: 34px;
        line-height: 36px;
        border: 1px solid rgba(187, 187, 187, 1);
        border-radius: 4px;
        padding: 0 10px;
        margin-bottom: 10px;
        width: 100%;
      }

      .sourceInput:focus {
        outline: none;
        border: 1px solid #454545;
      }

      .addBox {
        width: 100%;

        .targetInput {
          width: 44%;
          height: 34px;
          line-height: 36px;
          border: 1px solid rgba(187, 187, 187, 1);
          border-radius: 4px;
          padding: 0 10px;
        }

        .targetInput:focus {
          outline: none;
          border: 1px solid #454545;
        }

        button {
          width: 41%;
          height: 34px;
          background: rgba(69, 69, 69, 1);
          border-radius: 4px;
          border: 0px;
          font-size: 14px;
          color: rgba(255, 255, 255, 1);
          float: right;
          padding: 0;
        }
      }
    }

    .find {
      width: 100%;
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      position: relative;
      padding: 0 20px;

      div {
        position: relative;
        width: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: center;

        input {
          width: 100%;
          height: 34px;
          line-height: 36px;
          border: 1px solid rgba(187, 187, 187, 1);
          border-radius: 4px;
          padding: 0 10px;
          padding-right: 26px;
        }

        input:focus {
          outline: none;
          border: 1px solid #454545;
        }

        .search {
          position: absolute;
          right: 3%;
          top: 10px;
          cursor: pointer;
        }
      }

      .findBox {
        min-height: 50px;
        max-height: 180px;
        width: 100%;
        border: 1px solid rgba(187, 187, 187, 1);
        border-radius: 4px;
        text-align: left;
        padding: 10px;
        overflow: auto;

        li {
          padding: 3px 0;

          span {
            font-weight: 700;
          }
        }
      }

      h5 {
        margin: 10px 0;
        margin-top: 10px;
        text-align: left;
        width: 100%;
      }
    }
  }

  .hint::-webkit-scrollbar {
    width: 0 !important;
  }

  .hint {
    max-height: 160px;
    overflow: auto;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;

    li {
      margin: 0 20px;

      p {
        word-wrap: break-word;
        word-break: normal;
      }
    }
  }

  h4 {
    text-align: left;
    margin-top: 20px;
    margin-left: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(34, 34, 34, 1);

    h3 {
      width: 4px;
      height: 18px;
      background: rgba(69, 69, 69, 1);
      float: left;
      margin-right: 15px;
      position: relative;
      top: 4px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(34, 34, 34, 1);
    }
  }

  h5 {
    font-size: 16px;
    font-weight: bold;
    color: rgba(34, 34, 34, 1);
    width: 100%;
    text-align: left;
    margin: 20px 0;
  }
}

.lefBag {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  float: left;
  background: #fff;
  width: 47%;
}

.lef::-webkit-scrollbar {
  display: none;
}

.lef-box-main::-webkit-scrollbar {
  display: none;
}

/deep/ .lef-box-main {
  span[type] {
    margin-right: 3px !important;
  }
}

.lef {
  float: left;
  position: relative;
  height: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
  width: 49%;
  background: #fff;
  z-index: 50;
}

.rig {
  box-sizing: border-box;
  position: relative;
  height: 100%;
  // overflow-y: auto;
  width: 49%;
  float: right;
  background: #fff;
  z-index: 50;
}

.lef,
.rig {
  padding-top: 50px;

  .tit {
    padding-left: 10px;
    position: absolute;
    top: 20px;
    left: 20px;
    font-size: 18px;
    font-weight: bold;

    h3 {
      width: 4px;
      height: 18px;
      background: rgba(51, 144, 255, 1);
      float: left;
      margin-right: 15px;
      position: relative;
      top: 4px;
    }
  }
}

span:focus {
  outline: -webkit-focus-ring-color auto 0px !important;
}

#WordBox {
  position: absolute;
  padding: 5px;
  z-index: 1000;
  border-radius: 5px;
  background: #666666;
  color: #fff;
}

#bagBox {
  background: #f1f5ff;
  height: calc(100% - 115px);
  overflow: hidden;
}

.el-scrollbar {
  .el-scrollbar__view {
    .el-select-dropdown__item {
      padding: 0px 0px !important;
      text-align: center;

      a {
        display: block;
      }
    }
  }
}
</style>
